import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserProfile } from '../models/user-profile.model';
import { Rate } from '../models/rate.model';
import { Conversation } from '../models/chat.model';
import { MyChats } from '../models/mychats.model';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class MeService {
  constructor(private http: HttpClient) {}

  path = '/api/Me';
  fileUploadPath = '/api/Storage';

  getUserProfile(): Observable<UserProfile> {
    return this.http.get<UserProfile>(`${environment.API}${this.path}/Profile`);
  }

  updateUserProfile(data: UserProfile): Observable<any> {
    return this.http.put(`${environment.API}${this.path}/Profile`, data);
  }

  uploadProfileFile(userProfileId: string, file: File) {
    const formData = new FormData();

    formData.append(file.name, file);
    formData.append('userProfileId', userProfileId);

    return this.http.post<Comment>(
      `${environment.API}${this.fileUploadPath}/Profile`,
      formData,
    );
  }

  deleteProfileFile(userProfileId: string) {
    return this.http.delete<UserProfile>(
      `${environment.API}${this.fileUploadPath}/Profile/${userProfileId}`
    );
  }

  getWishListItems(): Observable<any> {
    return this.http.get(`${environment.API}${this.path}/Wishlist`);
  }

  getMyRating(): Observable<number> {
    return this.http.get<number>(`${environment.API}${this.path}/MyRating`);
  }

  getRatings(queryParams?: Map<string, any>): Observable<Rate[]> {
    const queryParametersString = this.buildQueryParameters(queryParams);
    return this.http.get<Rate[]>(
      `${environment.API}${this.path}/Ratings/${queryParametersString}`,
    );
  }

  getMyChats(): Observable<MyChats[]> {
    return this.http.get<MyChats[]>(`${environment.API}${this.path}/MyChats`);
  }

  protected buildQueryParameters(queryParameters?: Map<string, any>): string {
    if (queryParameters == null || queryParameters.size == 0) {
      return '';
    }

    let queryString = '?';

    for (let entry of queryParameters.entries()) {
      if (typeof entry[1] == 'object') {
        for (let val of Array.from(entry[1])) {
          queryString += entry[0] + '=' + val + '&';
        }
      } else {
        queryString += entry[0] + '=' + queryParameters.get(entry[0]) + '&';
      }
    }

    queryString = queryString.substring(0, queryString.length - 1);

    return queryString;
  }
}
